import { typeGuard } from '@/lib/utils';

export function isRequestCancelled(
  error: unknown,
  signal?: AbortSignal | null
) {
  if (signal?.aborted) {
    const reason: unknown = signal.reason;
    // Timeouts are failures; explicit cancellations (including custom reasons)
    // should not produce an error event when a user navigates away.
    return !(
      typeGuard<{ name: unknown }>(reason, 'name') &&
      reason.name === 'TimeoutError'
    );
  }
  return (
    typeGuard<{ name: unknown }>(error, 'name') && error.name === 'AbortError'
  );
}
